export default __webpack_public_path__ + "static/media/courseHybridIcon.8782ec52.svg";